import Vue from 'vue'

import Projects from './components/projects.vue'
const projects = () => new Vue(Projects)

import ProjectPresentation from './components/project-presentation.vue'
const presentation = () => new Vue(ProjectPresentation)

import News from './components/news.vue'
const news = () => new Vue(News)

import Search from './components/search.vue'
const search = () => new Vue(Search)

export { projects, presentation, news, search }
